import React from 'react';
import classNames from 'classnames';
import { Button } from 'antd';

import featureNames from '@utils/featureToggle/constants';
import { FeatureToggle } from '@components/common';

import DashboardLink from '../DashboardLink';
import DashboardDropdown from '../DashboardDropdown';
import styles from './index.less';

const DashboardTabs = ({
  id,
  className,
  list,
  tabs,
  isFetching,
  extraComponent,
}) => (
  <Button.Group className={classNames(styles.tabGroup, className)} id={id}>
    {
      tabs.map((item) => {
        const cls = classNames(
          styles.tab,
          {
            [styles.unsaved]: item.unsaved,
            [styles.fixed]: item.fixed,
          },
        );
        return (
          <DashboardLink
            key={item.id}
            dashboard={item}
            className={cls}
            activeClassName={styles.active}
          />
        );
      })
    }
    {extraComponent}
    <FeatureToggle feature={featureNames.SAVED_DASHBOARDS}>
      <DashboardDropdown
        isFetching={isFetching}
        list={list}
        className={classNames(styles.tab, styles.fixed)}
      />
    </FeatureToggle>
  </Button.Group>
);

DashboardTabs.defaultProps = {
  id: null,
  className: '',
  extraComponent: null,
};

export default DashboardTabs;
